import {oneOf, any, number, func, bool} from 'prop-types';
import {styled} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import ButtonContainer from 'r/ui/ButtonContainer';
import {unionContexts} from 'r/utils';
import {bgAccentTabs, focusNormal, headerTextHover, bgAccentMain} from 'r/Design';
import checkSvg from 'r/icons/check.svg';


const Wr = styled(ButtonContainer)`
  display: flex;
  align-items: center;
`;

const CheckboxIcon = styled.div`
  position: relative;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  background: ${props => props.$checked ? focusNormal : bgAccentTabs};
  border-radius: 3px;
  flex-shrink: 0;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    mask: url("${checkSvg}") no-repeat center;
    mask-size: ${props => props.$size * 0.75}px ${props => props.$size * 0.75}px;
    mask-type: cover;
    background: ${props => props.$checked ? headerTextHover : bgAccentMain};
    width: 100%;
    height: 100%;
  }
`;

export default unionContexts(
  Checkbox,
);

Checkbox.propTypes = forbidExtraProps({
  checked: bool.isRequired,
  disabled: bool,
  label: any,
  onClick: func,
  rectPosition: oneOf(['left', 'right']),
  size: number.isRequired,
  asDiv: bool,
});

function Checkbox({
  checked,
  disabled = false,
  label,
  onClick,
  rectPosition = 'left',
  size,
  asDiv,
}) {
  const _onClick = () => {
    if (!asDiv) {
      onClick();
    }
  };
  return (
    <Wr as={asDiv && 'div'} disabled={disabled} onClick={_onClick}>
      {rectPosition === 'left' && <CheckboxIcon $checked={checked} $size={size}/>}
      {label || null}
      {rectPosition === 'right' && <CheckboxIcon $checked={checked} $size={size}/>}
    </Wr>
  );
}
